<template>
  <div>
    <v-container fluid>
      <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
        <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>

      <v-card class="box">
        <v-toolbar flat dense class="toolbar">
          <v-toolbar-title>Transport Report</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-row justify="center" dense>
          <v-col cols="12" sm="3">
            <p><v-icon color="error">*</v-icon><b>Academic Year</b></p>
            <v-autocomplete color="#0F2027" dense rounded required v-model="ay" :items="ay_list" item-text="ay"
              item-value="id" label="Academic Year" outlined persistent-hint hint="Please Select Academic Year"
              @change="putnull()" />
          </v-col>
          <v-col cols="12" sm="3">
            <p><v-icon color="error">*</v-icon><b>Term</b></p>
            <v-autocomplete color="#0F2027" dense rounded v-model="filters.term" :items="termList" label="Term" outlined
              persistent-hint multiple clearable hint="Please Select Term" />
          </v-col>
          <v-col cols="12" sm="3">
            <p><v-icon color="error">*</v-icon><b>Standard</b></p>
            <v-autocomplete color="#0F2027" dense rounded required v-model="standard" :items="standard_list"
              item-text="standard" item-value="id" label="Standard" outlined persistent-hint multiple
              hint="Please Select Standard" @change="fetchTransportFeesRerort()" />
          </v-col>
        </v-row>
      </v-card>
      <v-card class="box" v-if="this.show_table == true">
        <v-toolbar class="toolbar" flat dense>
          <v-toolbar-title>
            <strong>Transport Report</strong>
          </v-toolbar-title>
        </v-toolbar><br />
        <v-row dense>
          <v-container fluid class="pa-0">
            <!-- Row 1: Export + Division, Route Stop, Route, Status -->
            <v-row align="center" justify="space-between">
              <!-- Export Button -->
              <v-col cols="12" sm="2" md="2">
                <v-btn rounded color="success" outlined @click="fnExcelReport('my-table-id', 'TransportReport')"
                  :loading="loader" block>
                  <v-icon left color="success">mdi-export</v-icon>
                  Export
                </v-btn>
              </v-col>

              <!-- Division -->
              <v-col cols="12" sm="2" md="2">
                <v-autocomplete flat hide-details rounded dense outlined label="Division" multiple clearable
                  :items="dataValueList('division')" v-model="filters.division" />
              </v-col>

              <!-- Route Stop -->
              <v-col cols="12" sm="2" md="2">
                <v-autocomplete flat hide-details rounded dense outlined label="Route Stop" multiple clearable
                  :items="dataValueList('routestop')" v-model="filters.routestop" />
              </v-col>

              <!-- Route -->
              <v-col cols="12" sm="2" md="2">
                <v-autocomplete flat hide-details rounded dense outlined label="Route" multiple clearable
                  :items="dataValueList('route')" v-model="filters.route" />
              </v-col>

              <!-- Status -->
              <v-col cols="12" sm="2" md="2">
                <v-autocomplete flat hide-details rounded dense outlined label="Status" multiple clearable
                  :items="statusList" v-model="filters.status" />
              </v-col>

              <!-- Student Status -->
              <v-col cols="12" sm="2" md="2">
                <v-autocomplete flat hide-details rounded dense outlined label="Student Status" multiple clearable
                  :items="studentStatuslist" v-model="filters.studentStatus" item-text="text" item-value="value"/>
              </v-col>
            </v-row>
          </v-container>
        </v-row>
        <br>
        <v-row dense>
          <v-col cols="12" sm="6" md="6">
          </v-col>
          <v-col cols="12" sm="6" md="6">
            <v-text-field v-model="search" append-icon="mdi-magnify" label="Search by student name or route stop"
              single-line hide-details></v-text-field>
          </v-col>
        </v-row>
        <div id="my-table-id">
          <v-simple-table class="elevation-1">
            <template>
              <thead>
                <tr>
                  <th>Sr. No.</th>
                  <th>PRN</th>
                  <th>Name</th>
                  <th>Contact No</th>
                  <th>Standard</th>
                  <th>Division</th>
                  <th>Joining Date</th>
                  <th>Route</th>
                  <th>Route Stop</th>
                  <th>Distance In KM</th>
                  <!-- Dynamically render term columns based on fixed sequence -->
                  <template v-for="term in termList" v-if="filters.term.includes(term)">
                    <th :key="term + '-header'" colspan="6">{{ term }}</th>
                  </template>
                  <!-- Show Total column only if all terms are selected -->
                  <th :key="'total-header'" colspan="3" v-if="filters.term.length === termList.length">Total</th>
                </tr>
                <tr>
                  <th>-</th>
                  <th>-</th>
                  <th>-</th>
                  <th>-</th>
                  <th>-</th>
                  <th>-</th>
                  <th>-</th>
                  <th>-</th>
                  <th>-</th>
                  <th>-</th>
                  <!-- Dynamically render sub-headers for each term in fixed sequence -->
                  <template v-for="term in termList" v-if="filters.term.includes(term)">
                    <th :key="term + '-to-pay'">To Pay</th>
                    <th :key="term + '-paid'">Paid Till Now</th>
                    <th :key="term + '-balance'">Balance</th>
                    <th :key="term + '-joining'">Joining Date</th>
                    <th :key="term + '-active'">Active/Inactive</th>
                    <th :key="term + '-cancel'">Cancel Date</th>
                  </template>
                  <!-- Show Total sub-headers only if all terms are selected -->
                  <th :key="'total-to-pay'" v-if="filters.term.length === termList.length">To Pay</th>
                  <th :key="'total-paid'" v-if="filters.term.length === termList.length">Paid Till Now</th>
                  <th :key="'total-balance'" v-if="filters.term.length === termList.length">Balance</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in filteredItems" :key="index">
                  <td>{{ index + 1 }}</td>
                  <td>{{ item.registration_number || 'NA' }}</td>
                  <td>{{ item.name || 'NA' }}</td>
                  <td>{{ item.mobile_no || 'NA' }}</td>
                  <td>{{ item.standard || 'NA' }}</td>
                  <td>{{ item.division || 'NA' }}</td>
                  <td>{{ item.joining_date || 'NA' }}</td>
                  <td>{{ item.route || 'NA' }}</td>
                  <td>{{ item.routestop || 'NA' }}</td>
                  <td>{{ item.distance || 'NA' }}</td>
                  <!-- Dynamically render term data based on fixed sequence -->
                  <template v-for="term in termList" v-if="filters.term.includes(term)">
                    <td :key="term + '-to-pay-data-' + index">{{ getTermValue(item, term, 0) || 'NA' }}</td>
                    <!-- To Pay -->
                    <td :key="term + '-paid-data-' + index">{{ getTermValue(item, term, 1) === 'NA' ? 0 :
                      getTermValue(item, term, 1)}}</td>
                    <!-- Paid Till Now -->
                    <!-- <td :key="term + '-balance-data-' + index">{{ getTermValue(item, term, 2) || 'NA' }}</td> -->
                    <td :key="term + '-balance-data-' + index">
                      {{ getTermValue(item, term, 2) === 'NA' ? 0 : getTermValue(item, term, 2) }}
                    </td>
                    <!-- Balance -->
                    <td :key="term + '-joining-data-' + index">{{ getTermValue(item, term, 3) || 'NA' }}</td>
                    <!-- Joining Date -->
                    <td :key="term + '-active-data-' + index">{{ getTermValue(item, term, 4) || 'NA' }}</td>
                    <!-- Active/Inactive -->
                    <td :key="term + '-cancel-data-' + index">{{ getTermValue(item, term, 5) || 'NA' }}</td>
                    <!-- Cancel Date -->
                  </template>
                  <!-- Show Total only if all terms are selected -->
                  <td :key="'total-to-pay-data-' + index" v-if="filters.term.length === termList.length">{{
                    calculateTotal(item, 'to_pay') || 'NA' }}</td>
                  <td :key="'total-paid-data-' + index" v-if="filters.term.length === termList.length">{{
                    calculateTotal(item, 'paid') === 'NA' ? 0 : calculateTotal(item, 'paid') }}</td>
                  <!-- <td :key="'total-balance-data-' + index" v-if="filters.term.length === termList.length">{{
                    calculateTotal(item, 'balance') || 'NA' }}</td> -->
                  <td :key="'total-balance-data-' + index" v-if="filters.term.length === termList.length">
                    {{ calculateTotal(item, 'balance') === 'NA' ? 0 : calculateTotal(item, 'balance') }}
                  </td>

                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
      </v-card>
    </v-container>
  </div>
</template>

<script>
  import axios from "axios";
  import "@/assets/css/color.css";

  export default {
    data: () => ({
      loader: false,
      snackbar_msg: "",
      color: "",
      snackbar: false,
      overlay: false,
      ay_list: [],
      ay: "",
      standard_list: [],
      filters: {
        division: [],
        routestop: [],
        route: [],
        term: [],
        status: [],
        studentStatus: [],
      },
      studentStatuslist: [
        { text: 'All', value: 3 },
        { text: 'Active', value: 0 },
        { text: 'Temporary inactive', value: 1 },
        { text: 'Permanent inactive', value: 2 }
      ],
      standard: "",
      show_table: false,
      transportFeesReportDetails: [],
      transport_installments: [],
      headers_list: [],
      search: "",
    }),
    computed: {
      filteredInstallments() {
        return this.filters.term.length
          ? this.transport_installments.filter(item => this.filters.term.includes(item.name))
          : this.transport_installments;
      },
      filteredItems() {
        return this.transportFeesReportDetails.filter(item => {


          const matchesSearch = this.search
            ? (item.name && item.name.toLowerCase().includes(this.search.toLowerCase())) ||
            (item.routestop && item.routestop.toLowerCase().includes(this.search.toLowerCase())) ||
            (item.mobile_no && item.mobile_no.toLowerCase().includes(this.search.toLowerCase())) ||
            (item.registration_number && item.registration_number.toLowerCase().includes(this.search.toLowerCase()))
            : true;


          const matchesDivision = this.filters.division.length
            ? this.filters.division.includes(item.division)
            : true;

          const matchesRoutestop = this.filters.routestop.length
            ? this.filters.routestop.includes(item.routestop)
            : true;

          const matchesRoute = this.filters.route.length
            ? this.filters.route.includes(item.route)
            : true;

          const matchesStatus = this.filters.status.length
            ? item.learner_transport_fees_installment_details.some((detail, index) => {
              if (index % 6 === 4) {
                const termIdx = Math.floor(index / 6);
                const termName = this.transport_installments[termIdx].name;
                if (termName && this.filteredInstallments.some(f => f.name === termName)) {
                  return this.filters.status.includes(detail);
                }
              }
              return false;
            })
            : true;

          // const matchesStudentStatus = this.filters.studentStatus.length
          //   ? this.filters.studentStatus.includes(item.student_status)
          //   : true;

          const matchesStudentStatus =
          this.filters.studentStatus.length
            ? this.filters.studentStatus.includes(3) // All selected
              ? true
              : this.filters.studentStatus.includes(item.student_status)
            : true;


          const noNAValuesForTerms = this.filteredInstallments.every(term => {
            const termIndex = this.termList.indexOf(term.name);
            if (termIndex === -1) return false;


            const detailValue = item.learner_transport_fees_installment_details[(termIndex * 6) + 0];

            return detailValue !== "NA";
          });

          return (
            matchesSearch &&
            matchesDivision &&
            matchesRoutestop &&
            matchesRoute &&
            matchesStatus &&
            matchesStudentStatus &&
            noNAValuesForTerms
          );
        });
      },

      termList() {
        return ['Term-1', 'Term-2', 'Annual'];
      },
      statusList() {
        return ['Active', 'Inactive'];
      },
      shouldShowTotal() {
        return this.filters.term.length === this.termList.length;
      },
    },
    methods: {
      filteredInstallmentDetails(details) {
        if (!this.filters.term.length || this.filters.term.length === this.transport_installments.length) {
          return details;
        }

        const result = [];
        const termIndices = {};
        this.transport_installments.forEach((item, idx) => {
          termIndices[item.name] = idx * 6;
        });

        this.filters.term.forEach(term => {
          const startIdx = termIndices[term];
          if (startIdx !== undefined && startIdx < details.length) {
            result.push(...details.slice(startIdx, startIdx + 6));
          } else {
            result.push("NA", "NA", "NA", "NA", "NA", "NA");
          }
        });

        return result;
      },
      dataValueList(column) {
        return [...new Set(this.transportFeesReportDetails.map(item => item[column]))];
      },
      putnull() {
        this.standard = "", this.transportFeesReportDetails = [], this.headers_list = [], this.show_table = false
      },
      fnExcelReport(id, name) {
        var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
        tab_text =
          tab_text +
          "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
        tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
        tab_text =
          tab_text +
          "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
        tab_text =
          tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
        tab_text =
          tab_text + "<table style='border-collapse:collapse;' border='1'>";
        var exportTable = $("#" + id).clone();
        exportTable.find("input").each(function (index, elem) {
          $(elem).remove();
        });
        exportTable.find("th, td").each(function () {
          $(this).css("border", "1px solid black");
        });
        tab_text = tab_text + exportTable.html();
        tab_text = tab_text + "</table></body></html>";
        const blob = new Blob([tab_text], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const filename = name + ".xls";
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, filename);
        } else {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = filename;
          a.click();
          window.URL.revokeObjectURL(url);
        }
      },
      fetchTransportFeesRerort() {
        if (!this.standard || this.standard.length === 0) {
          this.showSnackbar("red", "Please Select standard");
          this.overlay = false;
          return;
        }
        this.overlay = true;
        const data = {
          ay: this.ay,
          standard: this.standard,
          filters: this.filters,
        };
        axios
          .post("ParentTransport/fetchTransportFeesRerort", data)
          .then((res) => {
            if (res.data.flag == "YES") {
              this.transportFeesReportDetails = res.data.transportFeesReportDetails;
              this.transport_installments = res.data.transport_installments;
              if (this.transport_installments.length <= 0 || this.transportFeesReportDetails.length <= 0) {
                this.showSnackbar("red", "No Records Found...");
                return
              }
              this.headers_list = res.data.headers_list;
              this.show_table = true;
              this.overlay = false;
            } else if (res.data.flag == "No") {
              this.showSnackbar("red", res.data.snackbar);
              sessionStorage.setItem("error-trace", res.data.error_trace);
              this.overlay = false;
            }
          })
          .catch((error) => {
            this.showSnackbar("#b71c1c", "Something went wrong!!!");
            this.overlay = false;
          })
          .finally(() => {
            this.overlay = false;
          });
      },
      onLoad() {
        axios
          .post("ParentTransport/TransportFeesReport")
          .then((res) => {
            if (res.data.flag == "YES") {
              (this.ay_list = res.data.ay_list), (this.ay = res.data.curreny_ay);
              this.standard_list = res.data.standard_list;
              this.overlay = false;
            } else {
              this.showSnackbar("#b71c1c", res.data.status_reason);
            }
          })
          .catch((error) => {
            this.showSnackbar("#b71c1c", "Something went wrong!!!");
            this.overlay = false;
          })
          .finally(() => {
            this.overlay = false;
          });
      },
      showSnackbar(clr, msg) {
        this.snackbar = true;
        this.color = clr;
        this.snackbar_msg = msg;
      },
      getTermValue(item, term, offset) {
        const termIndex = this.termList.indexOf(term);
        if (termIndex === -1) {
          // Paid (1) & Balance (2) → 0
          return (offset === 1 || offset === 2) ? 0 : 'NA';
        }

        const detailIdx = termIndex * 6 + offset;
        const value = item.learner_transport_fees_installment_details[detailIdx];

        // Paid (1) & Balance (2) → NA / undefined → 0
        if ((offset === 1 || offset === 2 ) &&
          (value === 'NA' || value === undefined || value === null)) {
          return 0;
        }

        return value !== undefined && value !== null ? value : 'NA';
      },

      // Ensure calculateTotal remains as is
      calculateTotal(item, type) {
        const offsets = { to_pay: 0, paid: 1, balance: 2 };
        const offset = offsets[type];
        let total = 0;

        this.transport_installments.forEach((term, idx) => {
          const detailIdx = idx * 6 + offset;
          const value = item.learner_transport_fees_installment_details[detailIdx];

          if (value !== undefined && value !== "NA" && !isNaN(parseFloat(value))) {
            total += parseFloat(value);
          }
        });

        // Always return number, NA असेल तरी 0
        return total;
      },

    },
    mounted() {
      this.onLoad();
    },
    watch: {},
  };
</script>

<style scoped>
  tr,
  td,
  th {
    border: 1px solid #ccc;
    text-align: center;
    font-size: small;
  }

  tr,
  tbody {
    border-bottom: 1px solid #ccc;
    border: 1px solid #ccc;
    font-size: small;
  }

  td {
    margin: 0.3rem !important;
    padding: 0.4rem !important;
    font-size: small;
  }

  @media (min-width: 320px) {

    td,
    th {
      display: table-cell !important;
      font-size: small;
    }

    td+td,
    th+th {
      width: auto;
      font-size: small;
    }
  }

  v-simple-table {
    white-space: nowrap !important;
    text-align: center;
    font-size: small;
  }
</style>